<template>
  <div style="height: 100%;" class="modal-basicInfo">
    <el-form :model="addForm" ref="addForm" :disabled='disabled' :rules="rules">
      <el-row>

        <el-card>

          <div slot="header" class="clearfix">
            <span>基本信息</span>
          </div>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="头像">
                <el-upload
                    ref="heardImg"
                    class="avatar-uploader"
                    :action="uploadUrl"
                    list-type="picture-card"
                    :data='uploadData'
                    :show-file-list="false"
                    :on-success="handleImgSuccess"
                    style="margin-top:40px">
                  <el-image v-if="addForm.heardImg" :src="heardImgTemp" fit="cover" style="width: 150px;height: 150px;"></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="18" class="item">
              <el-row>
                <el-col :span="8" class="item">
                  <el-form-item label="姓名" required prop="name">
                    <el-input v-model="addForm.name" placeholder="请输入姓名" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="item">
                  <el-form-item label="紧急联系人" required prop="urgencyContact">
                    <el-input v-model="addForm.urgencyContact" clearable placeholder="请输入紧急联系人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="item">
                  <el-form-item label="紧急联系人手机" required prop="urgencyPhone">
                    <el-input v-model="addForm.urgencyPhone" maxlength="11" clearable
                              placeholder="请输入紧急联系人手机号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" class="item">
                  <el-form-item label="与紧急联系人的关系">
                    <el-select v-model="addForm.relation" placeholder="请选择与紧急联系人的关系"
                               style="width:100%" clearable>
                      <el-option
                          v-for="item in elderlyAllType.relationship"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="item">
                  <el-form-item label="老人手机号" required prop="phone">
                    <el-input v-model="addForm.phone" maxlength="11" placeholder="请输入老人手机号" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" class="item">
                  <el-form-item label="老人身份证号">
                    <el-input v-model="addForm.idCard" maxlength="18" @blur.native.capture="getAgeAndGender" placeholder="请输入老人身份证号" clearable></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-col>
          </el-row>

          <el-row>

            <el-col :span="6" class="item">
              <el-form-item label="老人类别" required prop="elderlyClassCode">
                <el-select v-model="addForm.elderlyClassCode" placeholder="请选择老人类别"
                           style="width:100%" clearable>
                  <el-option v-for="item in elderlyClassList"
                             :key="item.elderlyClassCode"
                             :label="item.name"
                             :value="item.elderlyClassCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="所属组织区域" required prop="zoneCode">
                <el-cascader placeholder="请选择所属组织区域" v-model="addForm.zoneCode" :options="zoneValue" :props="zoneProps" style="width:100%" clearable ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="地区">
                <el-cascader placeholder="请选择所属地区（可搜索）" v-model="addForm.areaCode" :options="areaValue" ref="cascaderAddr"
                             :props="props" @change="handleAreaChange" filterable style="width:100%" clearable>
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="家庭地址">
<!--                <el-input v-model="addForm.homeAddress" disabled placeholder="请选择详细地址" class="homeAddress">-->
<!--                  <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">选择</el-button>-->
<!--                </el-input>-->

                  <el-input v-model="addForm.homeAddress" placeholder="请输入老人家庭地址" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="民族">
                <el-select v-model="addForm.nationId" filterable placeholder="请选择民族" style="width:100%" clearable>
                  <el-option v-for="item in nationValue" :key="item.id" :label="item.nation" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="户籍性质">
                <el-select v-model="addForm.censusRegister" placeholder="请选择户籍性质" style="width:100%" clearable>
                  <el-option v-for="item in elderlyAllType.natureHRegistrater" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="政治面貌" >
                <el-select v-model="addForm.politicsStatus" placeholder="请选择政治面貌" style="width:100%" clearable>
                  <el-option v-for="item in elderlyAllType.politicalOutlook" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="居住情况">
                <el-select v-model="addForm.livingStatus" placeholder="请选择居住情况" style="width:100%" clearable>
                  <el-option v-for="item in elderlyAllType.livingConditions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="婚姻状况">
                <el-select v-model="addForm.isMarriage" placeholder="请选择婚姻状况" style="width:100%" clearable>
                  <el-option v-for="item in elderlyAllType.maritalValue" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="文化程度" prop="education">
                <el-select v-model="addForm.education" placeholder="请选择文化程度" style="width:100%" clearable>
                  <el-option v-for="item in elderlyAllType.education" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="用户状态">
                <el-select v-model="addForm.status" placeholder="请选择用户状态" style="width:100%" clearable>
                  <el-option v-for="item in statusValue" :key="item[0]" :label="item[1]" :value="item[0]"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="经纬度">
                <el-input v-model="lonlatstr" disabled placeholder="请抓取经纬度">
                  <el-button slot="append" @click="openBaiduMap">抓取</el-button>
                </el-input>
              </el-form-item>
            </el-col>

          </el-row>

<!--          <el-row>-->
<!--            <el-col :span="6" class="item">-->
<!--              <el-form-item label="残疾人证号">-->
<!--                <el-input v-model="addForm.disableCardNumber" placeholder="请输入残疾人证号" clearable></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="6" class="item">-->
<!--              <el-form-item label="紧急联系人身份证号">-->
<!--                <el-input v-model="addForm.urgencyIdCard" placeholder="请输入紧急联系人身份证号" clearable></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->

        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>服务信息</span>
          </div>

          <el-row>

            <el-col :span="6" class="item">
              <el-col :span="24" class="item">

                <el-form-item label="服务类型">
                  <el-select v-model="addForm.elderlyType" placeholder="请选择服务类型"
                             style="width:100%" clearable>
                    <el-option
                        v-for="item in elderlyAllType.elderlyType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" class="item">
                <el-form-item label="服务状态">
                  <el-select v-model="addForm.serviceStatus" style="width:100%" clearable>
                    <el-option
                        v-for="item in elderlyAllType.serviceStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-col>

            <el-col :span="18" class="item">
              <el-form-item label="服务需求">
                <el-checkbox-group v-model="addForm.serviceDemand" style="margin-top:40px">
                  <el-checkbox v-for="item in elderlyAllType.serviceDemand" :label="item.value" :key="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>

            <!--          <el-col :span="6" class="item">-->
            <!--            <el-form-item label="老人二维码">-->
            <!--              <div class="canvas-code" id="qrcode"></div>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->

          </el-row>

        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>健康状况</span>
          </div>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="自理能力">
                <el-select v-model="addForm.selfCardAbility" placeholder="请选择自理能力"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.selfCareAbility"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="心理状况">
                <el-select v-model="addForm.psychologyStatus" placeholder="请选择心理状况"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.mentalState"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="医疗保障情况">
                <el-select v-model="addForm.medicalSecurityStatus" placeholder="请选择医疗保障情况"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.medicalSecurity"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="血型">
                <el-select v-model="addForm.bloodType" clearable placeholder="请选择血型" style="width:100%">
                  <el-option
                      v-for="item in elderlyAllType.bloodType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="是否手术">
                <el-select v-model="addForm.isOperation" placeholder="请选择是否手术"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="手术原因">
                <el-input v-model="addForm.operationCause" clearable placeholder="请输入手术原因"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="手术时间">
                <el-date-picker
                    v-model="addForm.operationTime"
                    type="date"
                    placeholder="请选择手术日期"
                    :picker-options="pickerOptions0"
                    style="width:100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="主要疾病">
                <el-input v-model="addForm.illness" clearable placeholder="请输入主要疾病"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="过敏药物">
                <el-input v-model="addForm.irritabilityMedicine" clearable
                          placeholder="请输入过敏药物"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>生活方式</span>
          </div>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="饮食习惯">
                <el-select v-model="addForm.dietaryHabit" placeholder="请选择饮食习惯"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.dietHabits"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="吸烟状况">
                <el-select v-model="addForm.smokeStatus" placeholder="请选择吸烟状况"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.smokeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="饮酒频率">
                <el-select v-model="addForm.drinkStatus" placeholder="请选择饮酒频率"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.drinkType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="每次锻炼时间">
                <el-select v-model="addForm.exerciseTime" placeholder="请选择每次锻炼时间"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.exerciseTime"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="锻炼频率">
                <el-select v-model="addForm.exerciseStatus" placeholder="请选择锻炼频率"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.exercise"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="体育锻炼方式">
                <el-input v-model="addForm.exerciseType" clearable placeholder="请输入体育锻炼方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="饮酒种类">
                <el-input v-model="addForm.drinkKind" clearable placeholder="请输入饮酒种类"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">

            </el-col>
          </el-row>

        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>经济状况</span>
          </div>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="经济来源">
                <el-select v-model="addForm.pocketbook" placeholder="请选择经济来源"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.economicSources"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="月收入">
                <el-input v-model="addForm.monthlyIncome" clearable placeholder="请输入您的月收入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="月消费">
                <el-input v-model="addForm.monthlyConsumption" clearable
                          placeholder="请输入您的月消费"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>会员信息</span>
          </div>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="会员等级">
                <el-input v-model="addForm.memberLevel" clearable
                          placeholder="请输入会员等级"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="状态">
                <el-input v-model="addForm.cardStatus" clearable
                          placeholder="请输入状态"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="卡内码">
                <el-input v-model="addForm.cardInsideCode" clearable
                          placeholder="请输入卡内码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="押金">
                <el-input v-model="addForm.cashPledge" clearable
                          placeholder="请输入押金"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="卡编码">
                <el-input v-model="addForm.cardCoding" clearable
                          placeholder="请输入卡编码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="有效期">
                <el-input v-model="addForm.periodOfValidity" clearable
                          placeholder="请输入有效期"></el-input>
              </el-form-item>
            </el-col>

          </el-row>

        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>残疾人信息</span>
          </div>

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="是否是残疾人">
                <el-select v-model="addForm.isDisable" placeholder="请选择是否是残疾人"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.isDisable"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="残疾类别及等级">
                <el-select v-model="addForm.disableLevel" placeholder="请选择残疾类别及等级"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.disableLevel"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="残疾人证号">
                <el-input v-model="addForm.disableCardNumber" clearable placeholder="请输入残疾人证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="低保证号">
                <el-input v-model="addForm.diBaoCardNumber" clearable
                          placeholder="请输入低保证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="item">
              <el-form-item label="紧急联系人身份证号">
                <el-input v-model="addForm.urgencyIdCard" placeholder="请输入紧急联系人身份证号" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-card>


      </el-row>
    </el-form>

    <div style="background-color: white;height: 80px; width: 100% " v-show="!disabled">
      <div  style="margin-left: 43.5%;margin-top: 10px; ">
        <el-button type="primary" :loading="loading" style="width: 26%" @click="confirm('addForm')">保存</el-button>
      </div>
    </div>


    <BaiduMap ref="myBaiduMap" v-show="baiduMapShow" v-on:closeMap="closeMap" v-on:setMap="setMap"></BaiduMap>


  </div>
</template>

<script>

import elderly from "@/common/status";
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import idcardRules from "@/common/idcardRules";

const validatorIdNumber = (rule, value, callback) => {
  if(value){
    if (idcardRules(value)) {
      callback();
    } else {
      return callback(new Error('请输入正确的证件号'))
    }
  }else{
    callback()
  }

};

import BaiduMap from "./BaiduMap";

export default {

  name: "Role",
  data() {
    return {

      loading:false,

      baiduMapShow: false,

      uploadUrl: this.$shopUrl + 'Upload/Imgs',
      uploadData: {
        staffCode: getStaffCode(),
        timeStr: timeStr,
        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey)
      },

      elderlyClassList: [],
      areaValue: [],
      nationValue: [],

      zoneValue:[],
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      props: {
        emitPath: false,
        value: 'areaCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listAreaDTO'
      },

      //时间范围限制
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e6
        }
      },
      statusValue:[[0,'默认'],[1,'正常'],[2,'禁用']],

      heardImgTemp:'',

      addForm: {
        timeStr: timeStr,
        sign : hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        staffCode: getStaffCode(),

        elderlyCode:'',
        name: '',
        urgencyContact:'',
        urgencyPhone:'',

        phone:'',
        idCard: '',
        elderlyClassCode:'',
        zoneCode:'',
        homeAddress: '',

        lon: '',
        lat: '',
        heardImg: '',
        status:'',

        areaCode: '',
        elderlyType:'',
        nationId: '',
        isMarriage:'',
        politicsStatus:'',
        education:'',
        censusRegister: '',
        livingStatus:'',
        relation:'',
        selfCardAbility:'',
        psychologyStatus:'',
        bloodType:'',
        irritabilityMedicine:'',
        medicalSecurityStatus:'',
        illness:'',
        isOperation:'',
        operationCause:'',
        operationTime:'',
        dietaryHabit:'',
        smokeStatus:'',
        drinkStatus:'',
        drinkKind:'',
        exerciseType:'',
        exerciseStatus:'',
        exerciseTime:'',
        pocketbook:'',
        monthlyIncome:'',
        monthlyConsumption:'',
        memberLevel:'',
        cardInsideCode:'',
        cardCoding:'',
        periodOfValidity:'',
        serviceStatus:'',
        terminalCode:'',
        serviceDemand: [],
        cardStatus:'',
        cashPledge:'',

        isDisable:undefined,
        disableCardNumber:undefined,
        diBaoCardNumber:undefined,
        disableLevel:undefined,
        //disableCardNumber: '',
        urgencyIdCard: undefined,

      },

      rules:{
        name:[
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        urgencyContact:[
          { required: true, message: '请输入紧急联系人', trigger: 'blur' },
          { required: true, message: '请输入紧急联系人', trigger: 'change' },
        ],
        urgencyPhone:[
          { required: true, message: '请输入紧急联系人手机号', trigger: 'blur' },
          { required: true, message: '请输入紧急联系人手机号', trigger: 'change' },
        ],
        elderlyClassCode:[
          { required: true, message: '请选择老人类别', trigger: 'blur' },
        ],
        zoneCode:[
          { required: true, message: '请选择组织', trigger: 'blur' },
        ],
        phone:[
          { required: true, message: '请输入老人手机号', trigger: 'blur' },
          { required: true, message: '请输入老人手机号', trigger: 'change' },
        ],
        idCard:[
          { required: true, validator: validatorIdNumber, trigger: 'blur' },
          { required: true, message: '请输入身份证号', trigger: 'change' },
        ]
      },

      elderlyAllType: elderly,

      isSave:'',
      elData:'',
      disabled:false,

      lonlatstr:'',

    }
  },
  created() {

  },
  components: {
    BaiduMap
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
    },
  },
  methods: {
    init(isSave,elData,disabled) {
      //console.log(elData);

      this.isSave=isSave;

      if(disabled)this.disabled=disabled

      //this.$refs.addForm.resetFields();

      this.elData = elData;
      this.elderlyInit();


      this.getArea();
      this.getNation();
      this.getElderlyClassList();
      this.getZoneCode();

      this.lonlatstr = elData.lon+","+elData.lat;

    },


    elderlyInit(){

      this.addForm.elderlyCode = this.elData.elderlyCode;

      this.addForm.name=this.elData.name;
      this.addForm.urgencyContact=this.elData.urgencyContact;
      this.addForm.urgencyPhone=this.elData.urgencyPhone;
      this.addForm.elderlyClassCode=this.elData.elderlyClassCode;
      this.addForm.zoneCode = this.elData.zoneCode;

      this.addForm.phone=this.elData.phone;
      this.addForm.idCard=this.elData.idCard;
      this.addForm.homeAddress=this.elData.homeAddress;

      this.addForm.lon=this.elData.lon;
      this.addForm.lat=this.elData.lat;
      this.addForm.status=this.elData.status;

      this.addForm.heardImg = this.elData.heardImg;
      this.heardImgTemp = this.$imgUrl + this.elData.heardImg;


      this.addForm.livingStatus=this.isZero(this.elData.livingStatus);
      this.nation=this.elData.nation;
      if(this.elData.areaCode){
        this.addForm.areaCode=this.elData.areaCode;
      }
      this.addForm.elderlyType=this.isZero(this.elData.elderlyType);
      this.addForm.nationId=this.isZero(this.elData.sysNation);
      this.addForm.isMarriage=this.isZero(this.elData.isMarriage);
      this.addForm.politicsStatus=this.isZero(this.elData.politicsStatus);
      this.addForm.education=this.isZero(this.elData.education);
      this.addForm.censusRegister=this.isZero(this.elData.censusRegister);
      this.addForm.relation=this.isZero(this.elData.relation);
      this.addForm.selfCardAbility=this.isZero(this.elData.selfCardAbility);
      this.addForm.psychologyStatus=this.isZero(this.elData.psychologyStatus);
      this.addForm.bloodType=this.isZero(this.elData.bloodType);
      this.addForm.irritabilityMedicine=this.elData.irritabilityMedicine;
      this.addForm.medicalSecurityStatus=this.isZero(this.elData.medicalSecurityStatus);
      this.addForm.illness=this.elData.illness;
      this.addForm.isOperation=this.isZero(this.elData.isOperation);
      this.addForm.operationCause=this.elData.operationCause;
      this.addForm.operationTime=this.elData.operationTime;
      this.addForm.dietaryHabit=this.isZero(this.elData.dietaryHabit);
      this.addForm.smokeStatus=this.isZero(this.elData.smokeStatus);
      this.addForm.drinkStatus=this.isZero(this.elData.drinkStatus);
      this.addForm.drinkKind=this.elData.drinkKind;
      this.addForm.exerciseType=this.elData.exerciseType;
      this.addForm.exerciseStatus=this.isZero(this.elData.exerciseStatus);
      this.addForm.exerciseTime=this.isZero(this.elData.exerciseTime);
      this.addForm.pocketbook=this.isZero(this.elData.pocketbook);
      this.addForm.monthlyIncome=this.elData.monthlyIncome;
      this.addForm.monthlyConsumption=this.elData.monthlyConsumption;
      this.addForm.memberLevel=this.elData.memberLevel;
      this.addForm.cardInsideCode=this.elData.cardInsideCode;
      this.addForm.cardCoding=this.elData.cardCoding;
      this.addForm.periodOfValidity=this.elData.periodOfValidity;
      this.addForm.serviceStatus=this.isZero(this.elData.serviceStatus);
      this.addForm.terminalCode=this.elData.terminalCode;
      if(this.elData.serviceDemand){
        this.addForm.serviceDemand= JSON.parse(this.elData.serviceDemand);
      }
      this.addForm.cardStatus=this.elData.cardStatus;
      this.addForm.cashPledge=this.isZero(this.elData.cashPledge);

      // if(this.zoneValue != []){
      //   if(JSON.stringify(this.zoneValue).indexOf(this.elData.zoneCode) == -1){
      //     this.addForm.zoneCode = '';
      //   }
      // }

      this.addForm.isDisable=this.elData.isDisable;
      this.addForm.disableCardNumber=this.elData.disableCardNumber;
      this.addForm.diBaoCardNumber=this.elData.diBaoCardNumber;
      this.addForm.disableLevel=this.elData.disableLevel;
      this.addForm.urgencyIdCard=this.elData.urgencyIdCard;
      //this.addForm.disableCardNumber=this.elData.disableCardNumber;

    },

    getNation() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "SysNation/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.nationValue = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getElderlyClassList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyClass/List",
        data: {
          timeStr: timeStr,
          staffCode: getStaffCode(),
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey)
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.elderlyClassList = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getArea() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Area/ListAll",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listAreaDTO":\[\],/g, ''))
              this.areaValue = data
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getZoneCode(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log("zone");
        if (response.data.error === 0) {

          var data = JSON.stringify(response.data.data);
          //把空数组删除
          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;

          if(this.addForm.zoneCode != ''){
            if(JSON.stringify(this.zoneValue).indexOf(this.addForm.zoneCode) == -1){
              this.addForm.zoneCode = '';
            }
          }

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      })
    },



    handleImgSuccess(res, file) {
      console.log(file)
      this.addForm.heardImg = res.data.path;
      this.heardImgTemp = this.$imgUrl + res.data.path;
    },

    handleAreaChange() {
      var thsAreaCode = this.$refs.cascaderAddr.getCheckedNodes()
      this.thsArea = thsAreaCode[0].parent.label
    },

    openBaiduMap() {

      if(this.addForm.lon != null && this.addForm.lon != ''){
        let gcLonLat = this.bd_encrypta(this.addForm.lon,this.addForm.lat);
        this.$refs.myBaiduMap.init2(gcLonLat[0],gcLonLat[1]);
      }else{
        this.$refs.myBaiduMap.init();
      }


      this.baiduMapShow = true;
    },
    closeMap() {
      this.baiduMapShow = false
    },
    setMap(info) {
      this.baiduMapShow = false

      let gcLonLat = this.bMapTransWXMap(info.lng,info.lat);
      this.addForm.lon = gcLonLat[0];
      this.addForm.lat = gcLonLat[1];

      this.lonlatstr = info.lng +","+info.lat;

    },



    confirm(addForm){

      if(this.addForm.operationTime){
        this.addForm.operationTime=timefilters(this.addForm.operationTime);
      }

      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.editSubmit();
        } else {
          this.$message({type: 'warning', message: '请完善信息'});
          return false;
        }
      })

    },

    editSubmit(){

      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyAdm/CommEdit",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '保存成功！'});
              this.$emit("getElderlyData");
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )


    },



    isZero(data){

      if(data===0){
        return '';
      }else {
        return data;
      }

      //return data+1;
    },

    // GCJ-02 to BD-09
    bd_encrypta(gg_lon, gg_lat) {
      var X_PI = Math.PI * 3000.0 / 180.0;
      var x = gg_lon, y = gg_lat;
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
      var bd_lon = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lon, bd_lat]
    },

    // BD-09 to GCJ-02
    bMapTransWXMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return [lngs, lats]
    },


  }
}
</script>

<style lang="scss" scoped>

.modal-basicInfo {


  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #DCDFE6;
    color: #606266;
    cursor: not-allowed;
  }
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 150px;
    height: 150px;
  }
  .item{
    padding: 0 10px;
  }
  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  /deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  /deep/ .el-icon-plus {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  /deep/ .el-upload--picture-card{
    line-height: 150px;
  }

  /deep/ .el-card{
    box-shadow: none;
    border:  none;
    border-bottom: 1px solid  rgba(0,0,0,.1);
  }


}


</style>
